import SwitchUiLanguageMenu from "@ext/localization/actions/SwitchUiLanguageMenu";
import t from "@ext/localization/locale/translate";
import { useSetting, useSettingEffect } from "@ext/settings/logic/hooks";
import { refreshPage } from "../../../ui-logic/utils/initGlobalFuncs";

const SwitchUiLanguage = ({ size = "md" }: { size?: "md" | "lg" }) => {
	const [current, setLanguage] = useSetting("general.language");
	useSettingEffect("general.language", refreshPage);

	return (
		<SwitchUiLanguageMenu
			current={current}
			getLabel={(language) => t("current", language)}
			onChange={setLanguage}
			size={size}
			tooltip={t("change-language")}
		/>
	);
};

export default SwitchUiLanguage;
